import React, { useContext } from "react";

import { localizationContext } from "../contexts/localization";

export const withLocalizationContext = (Component) => (props) => {
    const localization = useContext<LocalizationConfig>(localizationContext);

    return <Component {...props} localization={localization} />;
};
